// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContextMenu_contextMenu__lCdys {
  position: fixed;
  background: var(--color-surface-light);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-card);
  box-shadow: var(--box-shadow);
  z-index: 1000;
  min-width: 120px;
  overflow: hidden;
}

.ContextMenu_menuItem__SzG-4 {
  padding: calc(var(--gutter) / 2) calc(var(--gutter) * 0.75);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: calc(var(--gutter) / 2);
  background-color: var(--color-surface-light);
}
.ContextMenu_menuItem__SzG-4:not(:last-child) {
  border-bottom: 1px solid var(--color-border);
}
.ContextMenu_menuItem__SzG-4:hover {
  background-color: var(--color-surface-interactive);
}
.ContextMenu_menuItem__SzG-4:hover.ContextMenu_selected__ks68j {
  background-color: var(--color-surface-interactive);
}
.ContextMenu_menuItem__SzG-4.ContextMenu_selected__ks68j {
  background-color: var(--color-surface-interactive);
}

.ContextMenu_checkmark__K7Abk {
  margin-left: auto;
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/ContextMenu/ContextMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,sCAAA;EACA,qCAAA;EACA,iCAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2DAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,4CAAA;AACF;AACE;EACE,4CAAA;AACJ;AAEE;EACE,kDAAA;AAAJ;AAEI;EACE,kDAAA;AAAN;AAIE;EACE,kDAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,2BAAA;AAHF","sourcesContent":[".contextMenu {\n  position: fixed;\n  background: var(--color-surface-light);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-card);\n  box-shadow: var(--box-shadow);\n  z-index: 1000;\n  min-width: 120px;\n  overflow: hidden;\n}\n\n.menuItem {\n  padding: calc(var(--gutter) / 2) calc(var(--gutter) * .75);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: calc(var(--gutter) / 2);\n  background-color: var(--color-surface-light);\n\n  &:not(:last-child) {\n    border-bottom: 1px solid var(--color-border);\n  }\n  \n  &:hover {\n    background-color: var(--color-surface-interactive);\n    \n    &.selected {\n      background-color: var(--color-surface-interactive);\n    }\n  }\n  \n  &.selected {\n    background-color: var(--color-surface-interactive);\n  }\n}\n\n.checkmark {\n  margin-left: auto;\n  color: var(--color-primary);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contextMenu": `ContextMenu_contextMenu__lCdys`,
	"menuItem": `ContextMenu_menuItem__SzG-4`,
	"selected": `ContextMenu_selected__ks68j`,
	"checkmark": `ContextMenu_checkmark__K7Abk`
};
export default ___CSS_LOADER_EXPORT___;
